<script setup>
  import ToolCard from "../components/ToolCard.vue";
</script>
<template>
  <div class="container mt-8 pb-20 flex flex-col gap-12">

    <div class="flex flex-col lg:grid lg:grid-cols-3 gap-8">
      <div class="col-span-2">
        <h1 class="text-6xl mb-4 text-primary">
          <img :src="$router.options.base+'/images/logo.svg'" class="inline-block w-24">
          PokéTools
        </h1>
        <h2 class="text-2xl mb-12">A group of tools for help creating Pokémon and fangames.</h2>
      </div>

      <div class="tool-card hover-shadow group" v-auto-animate>
        <div class="bg-primary text-white font-display text-lg p-4 rounded-t-lg">
          Changelog
        </div>
        <div class="p-4 overflow-auto max-h-[8rem]">
          <div class="flex flex-col gap-8">

            <div>
              <h3 class="font-bold mb-2">July 2026 - Added Cry Creator</h3>
              <p>Generate Pokémon cries by painting a spectrogram, or importing wavs and images! Also added Gen 9 data and fixed some bugs.</p>
            </div>

            <div>
              <h3 class="font-bold mb-2">October 2025 - 3+ Type Analysis</h3>
              <p>Check resistances for Pokémon with more than 2 types in the Typing Analyser!</p>
            </div>

            <div>
              <h3 class="font-bold mb-2">April 2024 - Big redesign!</h3>
              <p>New logo, new design, OpenGraph cards, and a way to link your current form data.</p>
            </div>

            <div>
              <h3 class="font-bold mb-2">February 2023 - Added Dark mode</h3>
            </div>

            <div>
              <h3 class="font-bold mb-2">November 2022 - Added Typing Analyzer</h3>
              <p>Added Typing Analyser, name exclusion on Movelist Generator </p>
            </div>

            <div>
              <h3 class="font-bold mb-2">August 2022 - Added Stat Jiggler</h3>
            </div>

            <div>
              <h3 class="font-bold mb-2">June 2022 - Started with Move Generator and Stardex</h3>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="grid items-stretch md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">


      <div class="md:col-span-2 lg:col-span-3">
        <router-link to="/stardex">
          <div class="tool-card hover-shadow group">
            <div class="bg-tool-stardex text-white font-display text-2xl p-4 rounded-t-lg">
              Stardex Classic: Pokédex Typing Analyser
            </div>
            <div class="p-4">
              <img
                class="float-right h-16 ml-4"
                src="https://bitcrush.org/poketools/_stardex/logo.png"
                alt="Stardex"
              />
              <p class="mb-4">
                Add your Pokémon and their types, and Stardex will show you the type distribution compared to each Pokémon game up to Gen 9 (Scarlet and Violet).
              </p>
              <p class="mb-4">
                <b>Stardex has now been updated and rehosted at <a href="https://tipsypastels.github.io/stardex/" target="_blank" class="text-link" @click.stop>https://tipsypastels.github.io/stardex/</a></b> by the original creator, tipsypastels.
                <br/>
                This version remains hosted as a "classic" version, but may be removed soon since the original is now receiving updates again. (Hint: on the new one, click the Import button!)
              </p>
              <router-link
                to="/stardex"
                class="button bg-tool-stardex text-white group-hover:bg-tool-stardex-hover shadow">
                Go
              </router-link>
            </div>
          </div>
        </router-link>
      </div>


      <ToolCard
        tool="Cry Creator"
        description="Use spectral editing to create Pokémon cries from images and sound files."
        :new="true"
      />

      <ToolCard
        tool="Movelist Generator"
        description="Generate movelists using a statistical algorithm from in-game data."
      />

      <ToolCard
        tool="Stat Jiggler"
        description="Set the power level of your Pokémon, and adjust its stats."
      />

      <ToolCard
        tool="Typing Analyser"
        description="Analyse the strengths and weaknesses of a Pokémon typing, or compare three types to find a balanced set."
      />

      <ToolCard
        tool="Weight Calculator"
        description="Get an estimate of how much a Pokémon should weigh, based on its shape and composition."
        :disabled="true"
      />

      <ToolCard
        tool="PokéSampler"
        description="An audio VST sampler containing curated, updated musical instrument soundfonts from gens 3 through 5."
        :disabled="true"
      />

    </div>


  </div>
</template>
